import { getConsumerFor } from "./consumer";
import {Subscription} from "@rails/actioncable";

export class ElectionCopierChannelSubscription {
  public subscription: Subscription;

  constructor(electionCopierId: number, { received, connected = undefined, disconnected = undefined }) {
    this.subscription = getConsumerFor(null).subscriptions.create(
      {
        channel: "ElectionCopierChannel",
        election_copier_id: electionCopierId,
      },
      {
        received,
        connected,
        disconnected,
      }
    );
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }
}